import getCurrentCreatorClientIdSelect from '../../../../creator-client/state/selectors/get-current-client-id'
import { getCurrentProfileSelect } from '../get-current'
import getByIdProfileSelector from '../get-by-id'

export function getCurrentOrCustomerProfileSelect (state) {
  const clientId = getCurrentCreatorClientIdSelect(state)
  if (!clientId) {
    return getCurrentProfileSelect(state)
  }
  return getByIdProfileSelector(clientId)(state)
}
